var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.33;}\n\t.st1{fill:#66A772;}\n\t.st2{opacity:0.85;}\n\t.st3{fill:#FF666F;}\n\t.st4{fill:#A57939;stroke:#A57939;stroke-width:5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000073716295086326100790000016730773370019830956_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.1,56c16.1,16.2,22.4,40.6,14.8,63.1L69.9,80.2L94.1,56z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.1,56L69.9,80.2L30.8,41.1c14.3-4.8,30-4.2,44,1.8C82.2,46.1,88.7,50.6,94.1,56z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.6,89.5v20c0,0.4-0.2,0.8-0.5,1l-14.7,14.8c-0.3,0.3-0.7,0.4-1.1,0.4c-0.8,0-1.5-0.7-1.5-1.5v-17 L60.6,89.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.6,89.4l-17.8,17.8H25.7c-0.8,0-1.5-0.7-1.5-1.5c0-0.4,0.1-0.8,0.4-1.1l14.8-14.7c0.3-0.3,0.7-0.4,1-0.4 H60.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "42.8,107.1 60.6,89.4 60.6,89.5 42.8,107.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.5,129.8c-0.5,0-0.9-0.1-1.4-0.3c-1.8-0.8-2.6-2.8-1.8-4.6c10.4-24.2,5.1-51.9-13.5-70.5 C90,48.5,83.3,44,75.8,40.7c-16.1-6.9-34.5-6.9-50.6,0c-1.8,0.8-3.8-0.1-4.6-1.8c-0.8-1.8,0.1-3.8,1.8-4.6 c17.9-7.7,38.3-7.7,56.2,0c8.4,3.6,15.8,8.7,22.2,15.1c20.6,20.7,26.5,51.4,14.9,78.3C115.1,129,113.8,129.8,112.5,129.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.9,121.6c-0.6,0-1.3-0.2-1.8-0.7L29.1,42.9c-1-1-1-2.6,0-3.5c1-1,2.6-1,3.5,0l78.1,78.1c1,1,1,2.6,0,3.5 C110.2,121.4,109.6,121.6,108.9,121.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,134.6c-1.1,0-2.3-0.2-3.3-0.7c-1-0.4-1.8-1-2.6-1.7c-2.4-2.4-3.1-6.1-1.8-9.2c0.7-1.7,1.3-3.2,1.7-4.6 c7.1-21.1,1.5-44.8-14.2-60.6c-5.3-5.3-11.5-9.5-18.5-12.6c-13.4-5.8-28.4-6.4-42.2-1.8c-1.4,0.5-2.9,1-4.6,1.8 c-2.1,0.9-4.3,0.9-6.4,0.1c-2.1-0.8-3.7-2.4-4.6-4.5c-0.9-2-0.9-4.3-0.1-6.4c0.8-2.1,2.4-3.7,4.5-4.6 c28.8-12.4,61.6-6.1,83.7,16.1c6.8,6.8,12.2,14.7,16,23.6c8.2,19.1,8.2,40.9,0,60c-0.9,2.1-2.5,3.7-4.6,4.5 C114.6,134.4,113.5,134.6,112.5,134.6z M50.5,35.4c8.6,0,17.3,1.8,25.4,5.2c7.6,3.3,14.4,7.9,20.1,13.6 c17,17.1,23.1,42.9,15.4,65.7c-0.5,1.5-1.1,3.2-1.9,5c-0.5,1.3-0.3,2.8,0.7,3.7c0.3,0.3,0.6,0.5,1,0.7c0.8,0.4,1.7,0.4,2.6,0.1 c0.8-0.3,1.5-1,1.9-1.8c7.7-17.8,7.7-38.2,0-56c-3.6-8.3-8.6-15.7-14.9-22c0,0,0,0,0,0C80,28.7,49.3,22.8,22.4,34.4 c-0.8,0.4-1.5,1-1.8,1.9c-0.3,0.8-0.3,1.8,0,2.6c0.7,1.7,2.7,2.5,4.4,1.8c1.8-0.8,3.5-1.4,5-1.9C36.7,36.5,43.6,35.4,50.5,35.4z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.1,114.4c-0.6,0-1.3-0.2-1.8-0.7c-1-1-1-2.6,0-3.5l89.5-89.5c1-1,2.6-1,3.5,0c1,1,1,2.6,0,3.5l-89.5,89.5 C39.4,114.1,38.8,114.4,38.1,114.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.6,44.9c-1.4,0-2.5-1.1-2.5-2.5V24.9h-17.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h20c1.4,0,2.5,1.1,2.5,2.5v20 C130.1,43.7,129,44.9,127.6,44.9z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ec02249.svg";
export { ForwardRef as ReactComponent };